import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../../../common/select';

const AcquisitionChannel = ({ options, className, leadAutoAssigned }) => (
  <div className={className}>
    <div className="c-label-new">Acquisition Channel</div>
    <Select
      className="c-select"
      name="leadId"
      disabled={leadAutoAssigned}
      parse={val => val || null}
      options={options}
      empty="Not Provided"
    />
  </div>
);
AcquisitionChannel.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  className: PropTypes.string,
  leadAutoAssigned: PropTypes.bool,
};
AcquisitionChannel.defaultProps = {
  options: [],
  className: '',
  leadAutoAssigned: false,
};

export default AcquisitionChannel;
